<template>
  <!-- to edit -->
  <v-container v-if="!create && edit" style="max-width: 1500px">
    <div v-if="loading" style="text-align: center">
      <v-progress-circular
        :width="4"
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <v-card v-else>
      <v-card-title
        class="font-light"
        style="display: inline-block; width: 100%"
      >
        <span class="float-left text-left"
          ><v-icon>mdi-account-cog</v-icon> Edit
          {{ this.selectedToEdit.name }} Role</span
        >
        <span class="float-right text-right">
          <v-btn
            class="mr-2"
            elevation="3"
            color="primary"
            @click="
              () => {
                this.edit = false;
                this.create = false;
              }
            "
          >
            cancel
          </v-btn>
          <v-btn
            elevation="3"
            color="primary"
            :disabled="!valid || this.editPermission.length == 0"
            @click="onUpdate()"
          >
            Save
          </v-btn>
        </span>
      </v-card-title>
      <v-spacer></v-spacer>

      <v-divider horizontal class="mx-0"></v-divider>
      <v-row no-gutters>
        <v-col cols="4"
          ><v-simple-table>
            <template>
              <thead style="background-color: #eff6ff">
                <tr>
                  <th class="center">Role</th>
                </tr>
              </thead>
              <tbody>
                <v-col>
                  <ul>
                    <li style="display: inline-block; width: 100%">
                      <v-form v-model="valid">
                        <v-text-field
                          v-model="editName"
                          label="Role Name"
                          placeholder="Role Name"
                          outlined
                          dense
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-form>
                    </li>
                  </ul>
                </v-col>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
        <v-divider vertical class="mx-0 bg-teal-600"></v-divider>
        <v-col
          ><v-simple-table>
            <template>
              <thead style="background-color: #eff6ff">
                <tr>
                  <th class="center">Permissions</th>
                </tr>
              </thead>
              <tbody>
                <v-container class="px-6">
                  <v-card-title>
                    <th></th>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                  <v-data-table
                    v-model="editPermission"
                    :items="permissionList"
                    :headers="headers"
                    item-key="name"
                    show-select
                    :search="search"
                    class="elevation-1"
                  >
                  </v-data-table>
                </v-container>
              </tbody>
            </template> </v-simple-table
        ></v-col>
      </v-row>
    </v-card>
  </v-container>
  <!-- to create -->
  <v-container v-else-if="create && !edit" style="max-width: 1500px">
    <div v-if="loading" style="text-align: center">
      <v-progress-circular
        :width="4"
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <v-card v-else>
      <v-card-title
        class="font-light"
        style="display: inline-block; width: 100%"
      >
        <span class="float-left text-left"
          ><v-icon>mdi-account-cog</v-icon>Create Custom Role</span
        >
        <span class="float-right text-right">
          <v-btn
            class="mr-2"
            elevation="3"
            color="primary"
            @click="
              () => {
                this.create = false;
              }
            "
          >
            cancel
          </v-btn>
          <v-btn
            elevation="3"
            color="primary"
            :disabled="!valid || this.selected.length == 0"
            @click="onSave()"
          >
            Save
          </v-btn>
        </span>
      </v-card-title>
      <v-spacer></v-spacer>

      <v-divider horizontal class="mx-0"></v-divider>
      <v-row no-gutters>
        <v-col cols="4"
          ><v-simple-table>
            <template>
              <thead style="background-color: #eff6ff">
                <tr>
                  <th class="center">Role</th>
                </tr>
              </thead>
              <tbody>
                <v-col>
                  <ul>
                    <li style="display: inline-block; width: 100%">
                      <v-form v-model="valid">
                        <v-text-field
                          v-model="roleName"
                          label="Role Name"
                          placeholder="Role Name"
                          outlined
                          dense
                          :rules="[rules.required]"
                        ></v-text-field>
<!--                        <v-switch-->
<!--                          v-model="isActive"-->
<!--                          label="Is Role Primary"-->
<!--                        ></v-switch>-->
                      </v-form>
                    </li>
                  </ul>
                </v-col>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
        <v-divider vertical class="mx-0 bg-teal-600"></v-divider>
        <v-col
          ><v-simple-table>
            <template>
              <thead style="background-color: #eff6ff">
                <tr>
                  <th class="center">Permissions</th>
                </tr>
              </thead>
              <tbody>
                <v-container class="px-6">
                  <v-card-title>
                    <th></th>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                  <v-data-table
                    v-model="selected"
                    :items="permissionList"
                    :headers="headers"
                    item-key="name"
                    show-select
                    :search="search"
                    class="elevation-1"
                  >
                  </v-data-table>
                </v-container>
              </tbody>
            </template> </v-simple-table
        ></v-col>
      </v-row>
    </v-card>
  </v-container>
  <!-- to view -->
  <v-container v-else-if="!edit && !create" style="max-width: 1500px">
    <div v-if="loading" style="text-align: center">
      <v-progress-circular
        :width="4"
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <v-card v-else>
      <v-card-title
        class="font-light"
        style="display: inline-block; width: 100%"
      >
        <span class="float-left text-left"
          ><v-icon>mdi-account-cog</v-icon> Custom Roles</span
        >
        <span class="float-right text-right">
          <v-btn
            elevation="3"
            color="primary"
            @click="
              () => {
                this.create = true;
                this.edit = false;
              }
            "
          >
            Create Custom Roles
          </v-btn>
        </span>
      </v-card-title>
      <v-spacer></v-spacer>

      <v-divider horizontal class="mx-0"></v-divider>
      <v-row no-gutters>
        <v-col
          ><v-simple-table>
            <template>
              <thead style="background-color: #eff6ff">
                <tr>
                  <th class="center">Roles</th>
                </tr>
              </thead>
              <tbody>
                <v-container class="px-6">
                  <v-card-title>
                    <th></th>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                  <v-data-table
                    :items="roleList"
                    :headers="headers"
                    item-key="name"
                    :search="search"
                    class="elevation-1 mx-12 px-8"
                  >
                    <template v-slot:item.actions="{ item }">
                      <v-btn @click="editItem(item)" color="success">
                        <v-icon left> mdi-pencil </v-icon>
                        Edit
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-container>
              </tbody>
            </template>
          </v-simple-table></v-col
        >
      </v-row>
    </v-card>
  </v-container>
</template>
<script>
import axios from "axios";
const querystring = require("querystring");
export default {
  data() {
    return {
      create: false,
      edit: false,
      valid: false,
      loading: false,
      search: "",
      singleSelect: true,
      selected: [],
      isActive: false,
      roleName: "",
      rules: {
        required: (value) => !!value || "Required.",
      },
      headers: [
        {
          text: "Role Name",
          sortable: true,
          value: "name",
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "actions",
        },
      ],
      taskId: [
        "can-view-dashboard",
        "can-view-practitioner",
        "can-add-practitioner",
        "can-change-his-password",
        "can-view-Position",
        "can-add-and-view-Position",
        "can-create-leave-request",
        "can-view-Facility-and-location",
        "can-Add-and-view-Facility-and-location",
        "can-view-adminUnit",
        // "can-manage-admin-settings",
        "can-view-all-reports",
        "can-view-staff-reports",
        "can-view-performance-reports",
        "can-view-separated-employee-reports",
        "can-view-retiring-employee-reports",
        "can-view-organization-summary-reports",
        "can-view-job-position-reports",
        "can-view-career-reports",
        "can-view-contract-reports",
        "can-view-leave-reports",
        // "can-manage-system-user"
      ],
      permissionList: [],
      roleList: [],
      selectedToEdit: null,
      editName: "",
      editPermission: [],
    };
  },
  async beforeMount() {
    this.fetchUserTask();
    this.fetchUserRole();
  },
  methods: {
    fetchUserTask() {
      this.taskId.map(async (task) => {
        let { data } = await await axios.get(`/fhir/Basic/${task}`);
        let subTasks = [];
        data.extension.map((d) => {
          if (
            d.url === "http://ihris.org/fhir/StructureDefinition/composite-task"
          ) {
            subTasks.push(d.valueReference.reference.split("/").pop());
          }
        });
        let name = data.extension.find(
          (d) =>
            d.url ===
            "http://ihris.org/fhir/StructureDefinition/ihris-basic-name"
        ).valueString;
        this.permissionList.push({ id: data.id, name: name, subTasks });
      });
    },
    async fetchUserRole() {
     let userLocation =  this.$store.state.user.facilityId
      let params = {
        _profile: "http://ihris.org/fhir/StructureDefinition/ihris-role",
        "related-location":`Location/${userLocation}`,
        _count: 100,
      };
      let url = "/fhir/Basic?_sort=name" + "&" + querystring.stringify(params);

      return new Promise((resolve) => {
        fetch(url)
          .then((response) => {
            if (response.ok) {
              response
                .json()
                .then((data) => {
                  data.entry.map((d) => {
                    let allowed = [
                      "ihris-role-hrofficer",
                      "ihris-role-open",
                      "ihris-role-hrmanager",
                      "ihris-role-dataclerk",
                      "ihris-role-admin",
                    ];
                    if (!allowed.includes(d.resource.id)) {
                      let name = d.resource.extension.find(
                        (d) =>
                          d.url ===
                          "http://ihris.org/fhir/StructureDefinition/ihris-basic-name"
                      )?.valueString;
                      this.roleList.push({ id: d.resource.id, name });
                    }
                  });
                  resolve();
                })
                .catch((err) => {
                  console.log("failed fetch facility", url, err);
                  resolve();
                });
            } else {
              resolve();
            }
          })
          .catch((err) => {
            console.log("failed fetch facility", url, err);
            resolve();
          });
      });
    },
    onSave() {
      return new Promise((resolve) => {
        let data = {};
        data.name = this.roleName;
        data.active = this.isActive;
        data.permissions = this.selected;
        axios
          .post(`/utils/customRole`, data)
          .then((response) => {
            if (response.status === 201) {
              this.$store.commit("setMessage", {
                type: "success",
                text: "Role Added successfully.",
              });
              this.$router.go();
            } else {
              this.$store.commit("setMessage", {
                type: "error",
                text: "Role could not be added.",
              });
            }
          })
          .catch((e) => console.log(e));
        resolve();
      });
    },
    editItem(item) {
      this.edit = true;
      this.selectedToEdit = item;
      this.editName = item.name;
      let url = `/fhir/Basic/${item.id}`;
      return new Promise((resolve) => {
        fetch(url)
          .then((response) => {
            if (response.ok) {
              response
                .json()
                .then((data) => {
                  let resource = data;
                  this.taskId.map(async (task) => {
                    let { data } = await await axios.get(`/fhir/Basic/${task}`);
                    if (resource.extension.length >= data.extension.length) {
                      let dataSubTasks = [];
                      let dataSubPermission = [];
                      resource.extension.map((d) => {
                        if (
                          d.url ===
                          "http://ihris.org/fhir/StructureDefinition/ihris-assign-task"
                        ) {
                          dataSubTasks.push(
                            d.valueReference.reference.split("/").pop()
                          );
                        }
                      });
                      data.extension.map((d) => {
                        if (
                          d.url ===
                          "http://ihris.org/fhir/StructureDefinition/composite-task"
                        ) {
                          dataSubPermission.push(
                            d.valueReference.reference.split("/").pop()
                          );
                        }
                      });

                      const containsAll = dataSubPermission.every((element) => {
                        return dataSubTasks.includes(element);
                      });
                      if (containsAll) {
                        let name = data.extension.find(
                          (d) =>
                            d.url ===
                            "http://ihris.org/fhir/StructureDefinition/ihris-basic-name"
                        ).valueString;
                        this.editPermission.push({
                          id: data.id,
                          name: name,
                          subTasks: dataSubPermission,
                        });
                      }
                    }
                  });
                  resolve();
                })
                .catch((err) => {
                  console.log("failed fetch facility", url, err);
                  resolve();
                });
            } else {
              resolve();
            }
          })
          .catch((err) => {
            console.log("failed fetch facility", url, err);
            resolve();
          });
      });
    },
    onUpdate() {
      return new Promise((resolve) => {
        let data = {};
        data.name = this.editName;
        data.permissions = this.editPermission;
        data.id = this.selectedToEdit.id;
        axios
          .post(`/utils/editCustomRole`, data)
          .then((response) => {
            console.log(response);
            if (response.status === 201) {
              this.$store.commit("setMessage", {
                type: "success",
                text: "Role Edited successfully.",
              });
              this.$router.go();
            } else {
              this.$store.commit("setMessage", {
                type: "error",
                text: "Editing role Fail.",
              });
            }
          })
          .catch((e) => console.log(e));
        resolve();
      });
    },
  },
  watch: {
    create: function () {
      this.search = "";
    },
    edit: function () {
      this.search = "";
    },
  },
};
</script>
<style scoped>
.custom-label input:checked + svg {
  display: block !important;
}
tr.selected {
  background-color: #1ab394;
}
.cursor {
  cursor: pointer;
}
.check {
  vertical-align: middle;
  text-align: center;
  display: inline-block;
  width: 100%;
}
.selected {
  background-color: honeydew !important;
  color: black;
}
.center {
  text-align-last: center;
}
</style>
